import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { AppState } from '@app/core/store/app.state';
import { selectAuthState } from '@app/core/store/auth/auth.selectors';

@Injectable({ providedIn: 'root' })
export class EmploymentStatusGuard implements CanActivate {
  constructor(private store: Store<AppState>, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.store.select(selectAuthState).pipe(
      filter((auth) => !auth.loading),
      take(1),
      map((auth) => auth.user?.employmentStatus === 'Terminated'
        ? this.router.parseUrl('/access-unavailable')
        : true)
    );
  }
}
